/**
 * Набор поддерживаемых операторов фильтрации.
 * Используется в схемах параметров, кодеке, валидаторе и QueryBuilder.
 */
var FilterOperators;
(function (FilterOperators) {
    /** Равно (=) */
    FilterOperators["eq"] = "eq";
    /** Не равно (!=) */
    FilterOperators["neq"] = "neq";
    /** Меньше (<) */
    FilterOperators["lt"] = "lt";
    /** Меньше или равно (<=) */
    FilterOperators["lte"] = "lte";
    /** Больше (>) */
    FilterOperators["gt"] = "gt";
    /** Больше или равно (>=) */
    FilterOperators["gte"] = "gte";
    /** Диапазон значений (между A и B) */
    FilterOperators["between"] = "between";
    /** Содержит подстроку */
    FilterOperators["contains"] = "contains";
    /** В списке значений */
    FilterOperators["in"] = "in";
    /** Пустое значение */
    FilterOperators["isEmpty"] = "isEmpty";
    /** Не пустое значение */
    FilterOperators["isNotEmpty"] = "isNotEmpty";
    /** Текстовый поиск */
    FilterOperators["text"] = "text";
})(FilterOperators || (FilterOperators = {}));
/**
 * Типы полей, поддерживаемые в схеме фильтров.
 * Определяют вид ввода и допустимые операторы.
 */
var FilterFieldTypes;
(function (FilterFieldTypes) {
    /** Не определен */
    FilterFieldTypes["unknown"] = "unknown";
    /** Строковое поле (поддерживает contains, equals и т.п.) */
    FilterFieldTypes["text"] = "text";
    /** Числовое поле int (операции сравнения и диапазоны) */
    FilterFieldTypes["int"] = "int";
    /** Числовое поле (операции сравнения и диапазоны) */
    FilterFieldTypes["number"] = "number";
    /** Логическое поле (true / false) */
    FilterFieldTypes["boolean"] = "boolean";
    /** Перечисление (enum, фиксированный набор значений) */
    FilterFieldTypes["enum"] = "enum";
    /** Поле даты (одиночное значение) */
    FilterFieldTypes["date"] = "date";
    /** Диапазон дат (от/до) */
    FilterFieldTypes["dateRange"] = "dateRange";
    /** Диапазон чисел (от/до) */
    FilterFieldTypes["numberRange"] = "numberRange";
    /** Уникальный идентификатор */
    FilterFieldTypes["guid"] = "guid";
})(FilterFieldTypes || (FilterFieldTypes = {}));

export { FilterFieldTypes, FilterOperators };
